import React from "react";
import Page2Hero from "../../components/page2Hero/page2Hero";
import Referrals from "../../components/page6-components/Referrals";
import ReferredUsers from "../../components/page6-components/ReferredUsers";

const Page6 = () => {
  return (
    <div>
      <Page2Hero></Page2Hero>
      <Referrals></Referrals>
      <ReferredUsers></ReferredUsers>
    </div>
  );
};

export default Page6;
